"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardSenderSubjectOption')(function discardSenderSubjectOption(state) {
    var optionState = state.optionState;
    optionState.showSenderOnTopInListView = null;
}));
//# sourceMappingURL=discardSenderSubjectOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-sender-subject-option/lib/actions/discardSenderSubjectOption.js
// module id = 5127
// module chunks = 2